import { render, staticRenderFns } from "./DocxViewer.vue?vue&type=template&id=4de450f4&"
import script from "./DocxViewer.vue?vue&type=script&lang=js&"
export * from "./DocxViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocxViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports